import styled from 'styled-components'

const Title = styled.div`
  margin-bottom: 40px;
  h1 {
    font-size: 42px;
  }
`

export default Title
